import React, { useState } from "react";
import faqData from "../../common/FAQjsn.json";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="px-6 py-12">
      <h2 className="text-4xl text-[#54BD95] text-center mb-8">
        Frequently Asked Questions
      </h2>
      <div className="max-w-full lg:max-w-5xl mx-auto flex flex-col gap-6">

        {faqData.map((item, index) => (
          <div
            key={index}
            className="bg-white rounded-xl overflow-hidden transition-all duration-300 shadow-lg hover:shadow-2xl"
          >
            <button
              className="w-full text-left flex justify-between items-center px-6 py-5 font-semibold text-gray-800 bg-gray-100 hover:bg-[#54BD95] hover:text-white transition-all duration-300 ease-in-out"
              onClick={() => handleClick(index)}
              aria-expanded={activeIndex === index}
            >
              {item.question}
              <span
                className={`transform transition-transform duration-300 ease-in-out ${activeIndex === index ? "rotate-180" : "rotate-0"
                  }`}
              >
                ▼
              </span>
            </button>

            <div
              className={`transition-all duration-500 ease-in-out overflow-hidden ${activeIndex === index ? "max-h-40 opacity-100 py-4 px-6" : "max-h-0 opacity-0 py-0 px-6"
                } bg-[#54BD95] text-white`}
            >
              {item.answer}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
